var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading-component",class:{ 'pb-10': _vm.size === 'large', 'pb-6': _vm.size !== 'large' }},[_c('h2',{staticClass:"heading-heading",class:_vm.size},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }